import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getSortedList } from '../searchThunks';
import { clearSortedList } from '../../common/thunks/searchThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';

const SLICE_NAME = 'sorted';

const initialState = {
    ...structuredClone(commonInitialState),
    sortValue: null,
};

export const sortedSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        setSortValue: (state, action) => {
            state.sortValue = action.payload;
        },
        clearSortValue: (state) => {
            state.sortValue = null;
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getSortedList }).addCase(
            clearSortedList,
            () => initialState,
        );
    },
});

export const { setSortValue, clearSortValue } = sortedSlice.actions;

export const sorted = sortedSlice.reducer;
